import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import * as React from 'react';
import * as Redux from 'react-redux';
import { STYLES_CARNET } from '../CarnetReducer';
import { componentsCarnet } from '../ConstCarnet';
import jsonStyles from '../StylesCarnet.json';

const ButtonsVerticalCarnet = ({ activo, id }) => {
  const dispatch = Redux.useDispatch();

  function addStyles(component) {
    const payload = {
      ...component,
      styles: activo[component.id] ?? jsonStyles[component.id],
    };
    dispatch({ type: STYLES_CARNET, payload });
  }

  return (
    <ButtonGroup orientation="vertical" aria-label="Vertical button group">
      {componentsCarnet.map((el) => {
        return (
          !el.notShow && (
            <Button
              variant={el.id === id ? 'contained' : 'outlined'}
              aria-label={el.name}
              key={el.id}
              onClick={() => addStyles(el)}
            >
              {el.name}
            </Button>
          )
        );
      })}
    </ButtonGroup>
  );
};

export default ButtonsVerticalCarnet;
